import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../views/Auth/Login';
import { useAuth } from '../contexts/AuthContext';

export default function AuthLayout() {
  const { isAuthenticated } = useAuth();
  
  // Set RTL direction
  document.documentElement.dir = 'rtl';
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/auth/login" replace />} />
    </Routes>
  );
}
